import React from 'react';
import Navigation from 'features/navigation/Navigation';

export const AppLayout = ({children}) => (
  <div>
    <Navigation>{children}</Navigation>
  </div>
);

export const LoginLayout = ({children}) => <div>{children} </div>;
